/**
 * Beschriftungen der Bestellpositions-Felder — 1:1 aus den `[Caption(...)]`-Attributen der DLL.
 * `ConfirmedDeliveryDate` trägt bewusst keine Beschriftung; dort zeigt das Grid den Feldnamen.
 */

import type { CaptionMap } from '../captions';
import type { OrderPosition } from '../entities';

const captions = {
  A0Empfaenger: 'Recipient',
  A0Name1: 'Recipient Name',
  AbzugReidem: 'Deduction Reidem',
  AnkunftsdatumBuchung: 'Date of Arrival Booking',
  AnzahlRgNachlauf: 'Sum Receipt Trailing',
  AnzahlRgSeefracht: 'Sum Receipt Sea Freight',
  AnzahlRgZoll: 'Sum Receipt Customs',
  Anzahlung: 'Down Payment',
  Artikelgruppe: 'Item Group',
  Artikelnummer: 'Item Number',
  Belegdatum: 'Receipt Date',
  Belegjahr: 'Receipt Year',
  Belegnummer: 'Receipt Number',
  BelegnummerBh: 'Accounting Receipt Number',
  BelId: 'Receipt ID',
  BelPosId: 'Receipt Position ID',
  Bemerkung: 'Remark',
  Bezeichnung1: 'Title',
  Bezeichnung2: 'Subtitle',
  BuchdatumAnz: 'Booking Date',
  BuchdatumRest1: 'Final Payment 1 Booking Date',
  BuchdatumRest2: 'Final Payment 2 Booking Date',
  BuchungSage: 'Sage Booking',
  Buchungsperiode: 'Booking Period',
  Cbm: 'Cubic Meters',
  CommentPsi: 'PSI Comment',
  Container: 'Container',
  Container_Anlieferdatum: 'Container Delivery Date',
  Container_AnlieferdatumEmpf: 'Container Delivery Recipient',
  Container_Anlieferuhrzeit: 'Container Delivery Time',
  Container_Bemerkung: 'Container Remark',
  Container_BLNummer: 'Container BL Number',
  Container_Containerleerrueckgabe: 'Container Empty Return',
  Container_ContainerNo: 'Container Number',
  Container_ContTyp1: 'Container Type',
  Container_DatumZugestellt: 'Container Delivered Date',
  Container_DepotDatum: 'Container Depot Date',
  Container_DepotName: 'Container Depot Name',
  Container_EingangErledigt: 'Container Entrance Completed',
  Container_Empfaenger: 'Container Recipient',
  Container_ETA: 'Container ETA',
  Container_ETD: 'Container ETD',
  Container_FruehestAnlieferdatum: 'Container Earliest Delivery Date',
  Container_Kw: 'Container Week',
  Container_NaechsteKW: 'Container Next Week',
  Container_Plombe: 'Container Seal',
  Container_PoD: 'Container PoD',
  Container_RueckgabeReferenz: 'Container Empty Return Reference',
  Container_Schiff: 'Container Ship',
  Container_Spediteur: 'Container Freight Forwarder',
  Container_TerminBestaetigungCIF1: 'Container Appointment Confirmation CIF',
  ContainerId: 'Container ID',
  Demurrage: 'Demurrage',
  EinfuhrUst: 'Import Tax',
  Einzelpreis: 'Unit Price',
  EkInklProvision: 'Purchase Price and Provision',
  EkStkInklProvision: 'Purchase Unit Price and Provision',
  Ereignis: 'Event',
  Export: 'Export',
  Forwarder: 'Forwarder',
  FoshanEfRgNr: 'Foshan Recipient Receipt Number',
  FoshanRgPos: 'Foshan Receipt Position',
  FrachtjeArtikel: 'Freight per Item',
  FrachtproStueck: 'Freight per Piece',
  IdLabelDeadline: 'ID-Label Deadline',
  IdLabelFinal: 'ID-Label Final',
  Incoterm: 'Incoterm',
  JahrBuchungBh: 'Booking Year',
  KalkEk: 'Purchase Price Calculative',
  KalkEkUebertragen: 'Purchase Price Calculative Transmitted',
  KepVersand: 'KEP Shipping',
  Kommentare: 'Comments',
  KommentarPsi: 'PSI Comment DE',
  Label: 'Label',
  Lagergeld: 'Storage Cost',
  LastExported: 'Last Export',
  LayoutErledigt: 'Layout Completed',
  LayoutsChecked: 'Layout Checked',
  Liefertermin: 'Date of Delivery',
  ManualDeadline: 'Manual Deadline',
  ManualFinal: 'Manual Final',
  Menge: 'Quantity',
  MonatBuchungBh: 'Booking Month',
  MusterQsErledigt: 'Test Sample Checked',
  Nachlauf: 'Trailing',
  NaechsterTerminLayouts: 'Layout Next Appointment',
  Order: 'Order',
  OrderRecepient: 'Order Recipient',
  OriginalDeliveryDate: 'Actual Date of Delivery',
  PackagingDeadline: 'Packaging Deadline',
  PackagingFinal: 'Packaging Final',
  PanelDeadline: 'Panel Deadline',
  PanelFinal: 'Panel Final',
  PeriodeBuchungBh: 'Accounting Period',
  PlanEta: 'Planned ETA',
  PlanEtd: 'Planned ETD',
  ProvisionYuanfan: 'Provision Yuanfan',
  PruefmusterQs: 'Test Sample',
  Psi: 'Pre-Shipment Inspection',
  PsiReleased: 'PSI Released',
  PsiReport: 'PSI Report',
  RecOrderNo: 'Recipient Order Number',
  Restzahlung1: 'Final Payment 1',
  Restzahlung2: 'Final Payment 2',
  SageBuchungDatum: 'Sage Booking Date',
  Seefracht: 'Sea Freight',
  Shipped: 'Shipped',
  ShippedDate: 'Shipped Date',
  ShippingMarksDeadline: 'Shipping Marks Deadline',
  ShippingMarksFinal: 'Shipping Marks Final',
  ShippingStatus: 'Shipping Status',
  VorId: 'Process ID',
  VorPosId: 'Process Position ID',
  Waehrungskurs: 'Currency Rate',
  WareWa: 'Goods Issue',
  WareWaYiyou: 'Deduction Reidem',
  WKz: 'Trade Mark',
  WunschLt: 'Desired Date of Delivery',
  Zoll: 'Customs',
  ZusatzkostenLogoRmb: 'Extra Cost Logo',
  ZusatzkostenMOQRmb: 'Extra Cost MOQ',
  ZusatzkostenPreiserhoehungRmb: 'Extra Cost Price Increase',
  ZusatzkostenSonstigesRmb: 'Extra Cost Misc',
  ZusatzkostenWSHRmb: 'Extra Cost WSH',
} satisfies Partial<Record<keyof OrderPosition, string>>;

export const orderPositionCaptions: CaptionMap = captions;
